import React from 'react';

type PageLayoutProps = {
  title: string;
  /** Optional count badge displayed next to the title (e.g. "21"). */
  count?: number | string | null;
  /** Short subtitle/description under the title. */
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
};

/**
 * Standard layout for list/detail pages. Includes:
 *   - page-enter motion (key'd on title so route changes animate)
 *   - title + optional count badge + optional subtitle
 *   - right-aligned action area
 */
export default function PageLayout({
  title,
  count,
  subtitle,
  actions,
  children,
}: PageLayoutProps) {
  return (
    <div className="page-wrapper page-enter" key={title}>
      <div className="page-header">
        <div className="page-header__title-group">
          <h1 className="page-title t-h1">
            {title}
            {count !== undefined && count !== null && (
              <span className="page-title__count" aria-label={`${count} items`}>
                {count}
              </span>
            )}
          </h1>
          {subtitle ? <div className="page-subtitle">{subtitle}</div> : null}
        </div>
        {actions ? <div className="page-actions">{actions}</div> : null}
      </div>
      <div className="page-body">{children}</div>
    </div>
  );
}
